import { useSearchStore } from '../searchStore';

export const searchIsActive = (searchId: string = '') => {
  const ws = useSearchStore.getState().searches[searchId]?.ws;
  if (!searchId) return false;
  return !!ws;
};
